import { createFileRoute } from '@tanstack/react-router';

import { StagesPage } from '@/features/plan/stages-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/stages')({
  component: StagesRoute,
});

function StagesRoute() {
  const { projectId } = Route.useParams();
  return <StagesPage projectId={projectId} />;
}
